import { render } from "./PrivacyComp.vue?vue&type=template&id=525fa216&scoped=true&ts=true"
import script from "./PrivacyComp.vue?vue&type=script&lang=ts"
export * from "./PrivacyComp.vue?vue&type=script&lang=ts"

import "./PrivacyComp.vue?vue&type=style&index=0&id=525fa216&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525fa216"]])

export default __exports__